import { motion, useReducedMotion } from 'motion/react';
import type { ReactNode } from 'react';

interface RevealProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  id?: string;
}

export function Reveal({ children, delay = 0, className = '', id }: RevealProps) {
  const reduced = useReducedMotion();
  return (
    <motion.div
      id={id}
      className={className}
      initial={false}
      whileInView={reduced ? undefined : {
        opacity: [0.78, 1],
        y: [18, 0],
        filter: ['blur(3px)', 'blur(0px)'],
        clipPath: ['inset(0 0 6% 0)', 'inset(0 0 0% 0)'],
      }}
      viewport={{ once: true, margin: '0px 0px -10% 0px' }}
      transition={{ duration: 0.68, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}
